export class EntranceTypes {
	public static readonly Bought = 'entranceTypeBought';
	public static readonly FromYoungAnimal = 'entranceTypeFromYoungAnimal';
    public static readonly FromYoungFemale = 'entranceTypeFromYoungFemale';
    public static readonly PoolEventTypeBought = 'entranceEventTypeBought'
}
